import { AbstractControl, ValidationErrors } from '@angular/forms';
import { ELanguage } from '@app/app.interface';
import { addDays, endOfDay, startOfDay } from 'date-fns';
import { stripHtmlTags } from '../admin-news.util';

export interface IDefaultNewsFormValues {
  startDate: Date;
  startTime: Date;
  endDate: Date;
  endTime: Date;
  priority: number;
  languageCode: ELanguage;
}

const DEFAULT_DURATION_DAYS = 7;

export function buildDefaultNewsFormValues(languageCode: ELanguage): IDefaultNewsFormValues {
  const now = new Date();
  const defaultEndDay = addDays(now, DEFAULT_DURATION_DAYS);

  return {
    endDate: endOfDay(defaultEndDay),
    endTime: endOfDay(defaultEndDay),
    languageCode,
    priority: 0,
    startDate: startOfDay(now),
    startTime: startOfDay(now),
  };
}

// Quill still writes markup (e.g. an empty heading) when only a format button is pressed, so a
// plain Validators.required sees a non-empty string. This checks the actual text content instead.
export function requiredQuillText(control: AbstractControl<string | null>): ValidationErrors | null {
  const { value } = control;

  return value && stripHtmlTags(value).length > 0 ? null : { required: true };
}
